import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { hasPermission } from "../scenes/Setting/permissionHelper";
import PermissionDenied from "../scenes/Setting/PermissionDenied";
import Loader from "./Loader/Lodaer";
import config from "../config/config";

const PrivateRoute = (props) => {
  const { component: Component,permissionKey, level = "VIEW_ONLY", ...restProps } = props;
const category=permissionKey
  const loggedIn = useSelector(({ userReducer }) => userReducer.loggedIn);

  const { userPermissionData, permissionLoading } = useSelector(
    (state) => state.rolePermissionReducer
  );
  const finalLevel=props.path==="/document/upload"?"READ_WRITE":level


  // ✅ New permission check
  const hasPermissionAllowed = category
    ? hasPermission(userPermissionData, category, finalLevel)
    : true;
  return (
    <Route
      {...restProps}
      render={(routeProps) => {
        //  Not logged in
        if (!loggedIn) {
          return <Redirect to="/login" />;
        }

        // ⏳ Permission loading
        if (config.enablePermissionCheck && permissionLoading) {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                width: "100vw",
                flexDirection: "column",
                gap: "10px",
                fontSize: "16px",
                color: "#000",
                backgroundColor: "#fff",
              }}
            >
              <Loader label="Loading..." />
            </div>
          );
        }

        // ✅ Permission check
        return hasPermissionAllowed ? (
          <Component {...routeProps} />
        ) : (
          <PermissionDenied />
        );
      }}
    />
  );
};

export default PrivateRoute;
